// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"595":"b8bf3d13","972":"44d0ef82"}[chunkId] + ".css";
};